<template>
    <input
        class="form-control-range slider"
        type="range"
        :min="min"
        :max="max"
        :step="step"
        :value="value"
        @input="onInput"
        @change="onChange">
</template>

<script>
import { debounce } from 'lodash';
import { isEdge } from '@/components/utils/compatibility';

export default {
    props: {
        value: { type: Number, default: 0 },
        min: { type: Number, default: 0 },
        max: { type: Number, default: 0 },
        step: { type: Number, default: 1 },
    },
    methods: {
        onChange (event) {
            const value = Number(event.target.value);
            this.emitChangeEvent(value);
        },
        emitChangeEvent (value) {
            this.$emit('change', value);
        },
        onInput (event) {
            const value = Number(event.target.value);
            this.$emit('input', value);

            // Without this line, in MS Edge, the 'change' event is not reliably called when clicking into the slider's range instead of using its thumb
            if (isEdge()) { this.debouncedChangeEvent(value); }
        },
        debouncedChangeEvent: debounce(function (value) {
            this.emitChangeEvent(value);
        }, 500),
    },
};
</script>

<style scoped lang="scss">
  // http://danielstern.ca/range.css/#/

  input[type=range] {
    -webkit-appearance: none;
    width: 100%;
    min-height: 50px;
    margin: 0;
    padding: 0;
  }

  // IE Workaround for smaller ms-track due to the box-shadow problem
  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    input[type=range] {
      margin-left: 5px;
    }
  }

  input[type=range]:focus {
    outline: none;
  }
  input[type=range]::-webkit-slider-runnable-track {
    width: 100%;
    height: 9px;
    cursor: pointer;
    box-shadow: 0px 0px 0.4px #000000, 0px 0px 0px #0d0d0d;
    background: $mb-lightgreen;
    border-radius: 10px;
    border: 0px solid #010101;
  }
  input[type=range]::-webkit-slider-thumb {
    box-shadow: 4px 4px 4px rgba(0, 0, 0, 0.25), 0px 0px 4px rgba(13, 13, 13, 0.25);
    border: 0px solid #000000;
    height: 38px;
    width: 38px;
    border-radius: 50px;
    background: $mb-white;
    cursor: pointer;
    -webkit-appearance: none;
    margin-top: -14.5px;
  }
  input[type=range]:focus::-webkit-slider-runnable-track {
    background: $mb-lightgreen;
  }
  input[type=range]::-moz-range-track {
    width: 100%;
    height: 9px;
    cursor: pointer;
    box-shadow: 0px 0px 0.4px #000000, 0px 0px 0px #0d0d0d;
    background: $mb-lightgreen;
    border-radius: 10px;
    border: 0px solid #010101;
  }
  input[type=range]::-moz-range-thumb {
    box-shadow: 4px 4px 4px rgba(0, 0, 0, 0.25), 0px 0px 4px rgba(13, 13, 13, 0.25);
    border: 0px solid #000000;
    height: 38px;
    width: 38px;
    border-radius: 50px;
    background: $mb-white;
    cursor: pointer;
  }
  input[type=range]::-ms-tooltip {
    display: none;
  }
  input[type=range]::-ms-track {
    width: 97%;
    height: 9px;
    cursor: pointer;
    background: transparent;
    border-color: transparent;
    color: transparent;
    outline: none;
    box-shadow: none;
    border: none;
  }
  input[type=range]::-ms-fill-lower {
    background: $mb-lightgreen;
    border: none;
    border-radius: 20px;
    box-shadow: none;
  }
  input[type=range]::-ms-fill-upper {
    background: $mb-lightgreen;
    border: none;
    border-radius: 20px;
    box-shadow: none;
  }
  input[type=range]::-ms-thumb {
    box-shadow: 4px 4px 4px rgba(0, 0, 0, 0.25), 0px 0px 4px rgba(13, 13, 13, 0.25);
    border: 0px solid #000000;
    height: 38px;
    width: 38px;
    border-radius: 50px;
    background: $mb-white;
    cursor: pointer;
    margin-top: -2px;
    margin-right: 11px;
  }
  input[type=range]:focus::-ms-fill-lower {
    background: $mb-lightgreen;
  }
  input[type=range]:focus::-ms-fill-upper {
    background: $mb-lightgreen;
  }
</style>
